// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"600936f6526b9f458e21","777":"d6721b29b7eef1e10682"}[chunkId] + ".chunk.js";
};